var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{staticClass:"stroke no-fill"},[_c('path',{attrs:{"d":"M9.625 9.64992V21.9999M1 9.64992H24M1.95833 3H23.0417C23.5709 3 24 3.42533 24 3.95V21.05C24 21.5747 23.5709 22 23.0417 22H1.95833C1.42906 22 1 21.5747 1 21.05V3.95C1 3.42533 1.42906 3 1.95833 3Z","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }